import { Badge } from "@/components/ui/badge";
import { dynamicCodeLabel, dynamicCodeTooltip } from "@/lib/codeMetrics";

/** "yes"/"no" for a job's dynamic-code flag (SQLite 0/1), with a tooltip
 *  explaining that "yes" means the interpreter was included. */
export function DynamicCodeBadge({ value }: { value: number | null }) {
  if (value == null) return <span className="text-muted-foreground">—</span>;
  return (
    <Badge
      variant={value === 1 ? "warning" : "secondary"}
      title={dynamicCodeTooltip(value)}
      className="cursor-help"
    >
      {dynamicCodeLabel(value)}
    </Badge>
  );
}
